import { messages } from './messages';

export const CURRENCY_OPTIONS = [
  { value: '$', label: messages['field-settings.currency-label-dollar'] },
  { value: '€', label: messages['field-settings.currency-label-euro'] },
  { value: '£', label: messages['field-settings.currency-label-pound'] },
  { value: '¥', label: messages['field-settings.currency-label-yen'] },
  { value: 'A$', label: messages['field-settings.currency-label-australian-dollar'] }
];

export const MAX_DECIMAL_PLACES = 5;
